
import { useState } from "react";
import { Pencil, Save, X } from "lucide-react";

const PersonalDetails = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        gender: "Female",
        dob: "1985-07-10",
        maritalStatus: "Married",
        religion: "Hindu",
        caste: "Caste",
        presentHouse: "Present House",
        anniversaryDate: "Anniversary Date",
        bloodGroup: "Blood Group",
        fatherName: "Father Name",
        panNumber: "Pan Number",
        spouseName: "Spouse Name",
        adharNumber: "Adhar Number",
        identificationMark: "Identification Mark",
        hobbies: "Hobbies",
        height: "Height",
        weight: "Weight",
        hiringSource: "Hiring Source",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSave = () => {
        setIsEditing(false);
    };

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Personal Details</h5>
                <div>
                    {isEditing && (
                        <button onClick={handleSave} className="btn btn-success btn-sm me-2">
                            <Save size={18} className="me-1" /> Save
                        </button>
                    )}
                    <button onClick={() => setIsEditing(!isEditing)} className="border-0 bg-transparent">
                        {isEditing ? <X className="text-danger" size={20} /> : <Pencil className="text-primary" size={20} />}
                    </button>
                </div>
            </div>

            <div className="card-block">
                <div className="row mb-3">
                    {/* Gender */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Gender</label>
                        {isEditing ? (
                            <select name="gender" className="form-control input-me f-14" value={formData.gender} onChange={handleChange}>
                                <option>Male</option>
                                <option>Female</option>
                                <option>Other</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.gender}</p>
                        )}
                    </div>

                    {/* Date of Birth */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Date of Birth</label>
                        {isEditing ? (
                            <input type="date" name="dob" className="form-control input-me f-14" value={formData.dob} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.dob}</p>
                        )}
                    </div>

                    {/* Marital Status */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Marital Status</label>
                        {isEditing ? (
                            <select name="maritalStatus" className="form-control input-me f-14" value={formData.maritalStatus} onChange={handleChange}>
                                <option>Married</option>
                                <option>Unmarried</option>
                            </select>
                        ) : (
                            <p className="mb-0 f-13">{formData.maritalStatus}</p>
                        )}
                    </div>
                    {/* Religion */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Religion</label>
                        {isEditing ? (
                            <input type="text" name="religion" className="form-control input-me f-14" value={formData.religion} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.religion}</p>
                        )}
                    </div>
                    {/* Caste */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Caste</label>
                        {isEditing ? (
                            <input type="text" name="caste" className="form-control input-me f-14" value={formData.caste} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.caste}</p>
                        )}
                    </div>
                    {/* Present House */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Present House</label>
                        {isEditing ? (
                            <input type="text" name="presentHouse" className="form-control input-me f-14" value={formData.presentHouse} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.presentHouse}</p>
                        )}
                    </div>
                    {/* Anniversary Date */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Anniversary Date</label>
                        {isEditing ? (
                            <input type="date" name="anniversaryDate" className="form-control input-me f-14" value={formData.anniversaryDate} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.anniversaryDate}</p>
                        )}
                    </div>
                    {/* Blood Group */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Blood Group</label>
                        {isEditing ? (
                            <input type="text" name="bloodGroup" className="form-control input-me f-14" value={formData.bloodGroup} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.bloodGroup}</p>
                        )}
                    </div>
                    {/* Father Name */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Father Name</label>
                        {isEditing ? (
                            <input type="text" name="fatherName" className="form-control input-me f-14" value={formData.fatherName} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.fatherName}</p>
                        )}
                    </div>
                    {/* Pan Number */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Pan Number</label>
                        {isEditing ? (
                            <input type="text" name="panNumber" className="form-control input-me f-14" value={formData.panNumber} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.panNumber}</p>
                        )}
                    </div>
                    {/* Spouse Name */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Spouse Name</label>
                        {isEditing ? (
                            <input type="text" name="spouseName" className="form-control input-me f-14" value={formData.spouseName} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.spouseName}</p>
                        )}
                    </div>
                    {/* Adhar Number */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Adhar Number</label>
                        {isEditing ? (
                            <input type="text" name="adharNumber" className="form-control input-me f-14" value={formData.adharNumber} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.adharNumber}</p>
                        )}
                    </div>
                    {/* Height */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Height</label>
                        {isEditing ? (
                            <input type="text" name="height" className="form-control input-me f-14" value={formData.height} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.height}</p>
                        )}
                    </div>
                    {/* Weight */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Weight</label>
                        {isEditing ? (
                            <input type="text" name="weight" className="form-control input-me f-14" value={formData.weight} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.weight}</p>
                        )}
                    </div>
                    {/* Hiring Source */}
                    <div className="col-lg-4 mb-3">
                        <label className="form-label">Hiring Source</label>
                        {isEditing ? (
                            <input type="text" name="hiringSource" className="form-control input-me f-14" value={formData.hiringSource} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.hiringSource}</p>
                        )}
                    </div>
                    {/* Identification Mark */}
                    <div className="col-lg-6 mb-3">
                        <label className="form-label">Identification Mark</label>
                        {isEditing ? (
                            <input type="text" name="identificationMark" className="form-control input-me f-14" value={formData.identificationMark} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.identificationMark}</p>
                        )}
                    </div>
                    {/* Hobbies */}
                    <div className="col-lg-6 mb-3">
                        <label className="form-label">Hobbies</label>
                        {isEditing ? (
                            <input type="text" name="hobbies" className="form-control input-me f-14" value={formData.hobbies} onChange={handleChange} />
                        ) : (
                            <p className="mb-0 f-13">{formData.hobbies}</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PersonalDetails;
